module.exports = __webpack_public_path__ + "images/feature/20160901_05-9d3c83c1e78642f1912917a2817de6f4.png";